import root from 'window-or-global';

export default function startTalon({flow, onSuccess, onFailed, onCancel}) {
  if (!root.talon) {
    handleSuccess(); // in case user can't load talon script
    return;
  }

  function handleExecute() {
    root.talon.execute(flow);
  }

  function handleSuccess(...args) {
    onSuccess(...args);
  }

  function handleCancel(...args) {
    onCancel(...args);
  }

  function handleError(...args) {
    console.error('talon error');
    onFailed(...args);
  }

  function runTalon() {
    if (!root.talon.flows[flow]) {
      loadTalon();
    }
    const currentFlow = root.talon.flows[flow];
    currentFlow.config.onComplete = handleSuccess;
    currentFlow.config.onClosed = handleCancel;
    currentFlow.config.onFailed = handleError;
    if (currentFlow.ready) {
      handleExecute();
    } else {
      currentFlow.config.onReady = function () {
        handleExecute();
      };
    }
  }

  function loadTalon() {
    root.talon.load({
      flow,
      onReady: () => {
        handleExecute();
      },
      onComplete: handleSuccess,
      onClosed: handleCancel,
      onError: handleError,
    });
  }

  runTalon();
}
